import React, { createContext, useContext, useState } from 'react';

const SearchTermsContext = createContext();

export const SearchTermsProvider = ({ children }) => {
    const [searchTerms, setSearchTerms] = useState([]);

    const addSearchTerm = (term) => {
        if (!searchTerms.includes(term)) {
            setSearchTerms((prevTerms) => [...prevTerms, term]);
        }
    };

    const removeSearchTerm = (term) => {
        setSearchTerms((prevTerms) => prevTerms.filter((t) => t !== term));
    };

    const clearSearchTerms = () => {
        setSearchTerms([]);
    };

    return (
        <SearchTermsContext.Provider
            value={{ searchTerms, addSearchTerm, removeSearchTerm, clearSearchTerms }}
        >
            {children}
        </SearchTermsContext.Provider>
    );
};

export const useSearchTerms = () => useContext(SearchTermsContext);
